import {
  ApiOutlined,
  CloudUploadOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { Attachments, Sender } from "@ant-design/x";
import { Badge, Button, Divider, Flex, Switch, theme } from "antd";
import { useEffect, useRef, useState } from "react";

export default function ChatSender({
  loading,
  handleSend,
  handleCancel,
  clearSender,
  setClearSender,
  deepThinking,
  debugMode,
  handleDebugThinking,
}) {
  const { token } = theme.useToken();

  const ICON_STYLE = {
    fontSize: "18px",
    color: loading ? token.colorTextDisabled : token.colorText,
  };

  const [openHeader, setOpenHeader] = useState(false);
  const [fileItems, setFileItems] = useState([]);

  const [sendValue, setSendValue] = useState("");
  const senderRef = useRef(null);
  const attachmentsRef = useRef(null);

  // For handle user paste file in sender
  function handlePasteFile(firstFile, files) {
    var _a;
    for (const file of files) {
      (_a = attachmentsRef.current) === null || _a === void 0
        ? void 0
        : _a.upload(file);
    }
    setOpenHeader(true);
  }

  // For clear the sender value (happens on user submit value or user change active conversation)
  useEffect(() => {
    if (clearSender) {
      setSendValue(null);
      setFileItems([]);
      setOpenHeader(false);
    }
    setClearSender(false);
  }, [clearSender]);

  return (
    <Sender
      ref={senderRef}
      loading={loading}
      value={sendValue}
      allowSpeech={true}
      disabled={loading}
      onChange={(value) => setSendValue(value)}
      onCancel={handleCancel}
      onPasteFile={handlePasteFile}
      onSubmit={(value) => handleSend(value, fileItems)}
      header={
        <>
          <Sender.Header
            title="Attachments"
            open={openHeader}
            onOpenChange={setOpenHeader}
            style={{
              content: {
                padding: 0,
              },
            }}
            forceRender
          >
            <Attachments
              ref={attachmentsRef}
              beforeUpload={() => false}
              items={fileItems}
              onChange={({ fileList }) => setFileItems(fileList)}
              placeholder={(type) =>
                type == "drop"
                  ? { title: "Drop file here" }
                  : {
                      icon: <CloudUploadOutlined />,
                      title: "Upload files",
                      description: "Click or drag files to this area to upload",
                    }
              }
              getDropContainer={() => {
                var _a;
                return (_a = senderRef.current) === null || _a === void 0
                  ? void 0
                  : _a.nativeElement;
              }}
            />
          </Sender.Header>
        </>
      }
      footer={({ components }) => {
        const { SendButton, LoadingButton, SpeechButton } = components;
        return (
          <Flex justify="space-between" align="center">
            <Flex gap={"small"} align="center">
              <Badge dot={fileItems.length > 0 && !openHeader}>
                <Button
                  icon={<LinkOutlined />}
                  type="text"
                  onClick={() => setOpenHeader(!openHeader)}
                  style={ICON_STYLE}
                  disabled={loading}
                />
              </Badge>
              {/* <Divider type="vertical" />
              <span>Debug Mode</span>
              <Switch
                size="small"
                disabled={loading}
                value={debugMode}
                onChange={(value) => handleDebugThinking(value, "debug")}
              /> */}
              <Divider type="vertical" />
              <span>Deep Thinking</span>
              <Switch
                size="small"
                disabled={loading}
                value={deepThinking}
                onChange={(value) => handleDebugThinking(value, "thinking")}
              />
            </Flex>
            <Flex align="center">
              <Button
                type="text"
                style={ICON_STYLE}
                icon={<ApiOutlined />}
                disabled={loading}
              />
              <Divider type="vertical" />
              <SpeechButton style={ICON_STYLE} />
              <Divider type="vertical" />
              {loading ? (
                <LoadingButton type="default" />
              ) : (
                <SendButton type="primary" />
              )}
            </Flex>
          </Flex>
        );
      }}
      actions={false}
    />
  );
}
